export default varName => {
  return window._env_?.[varName] ?? process.env[varName] ?? '';
};
